import styled from '@emotion/styled';
import Box from '@mui/material/Box';

export const LeoPromotionBadgeWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  height: '100%'
});
